import { render } from "./ParagraphComponent.vue?vue&type=template&id=3dada7dc&scoped=true"
import script from "./ParagraphComponent.vue?vue&type=script&lang=js"
export * from "./ParagraphComponent.vue?vue&type=script&lang=js"

import "./ParagraphComponent.vue?vue&type=style&index=0&id=3dada7dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dada7dc"]])

export default __exports__